import {
  getWindowYScroll,
  getWindowHeight,
  getDocumentHeight,
  listener,
  ListenerTypes,
} from "../shared";

export const ViewportScroll = (() => {
  const getScrollPercentage = () => {
    return Math.round(
      ((getWindowYScroll() + getWindowHeight()) / getDocumentHeight()) * 100
    );
  };

  const onScrollPercentageHandler = () => {
    const scrollPercentage = getScrollPercentage();
    listener.emit(ListenerTypes.scrollPercentage, scrollPercentage);
  };

  const onScrollHandler = () => {
    onScrollPercentageHandler();
  };

  const setListener = () => {
    document.body.addEventListener("touchmove", onScrollHandler);
    window.addEventListener("scroll", onScrollHandler);

    listener.set(ListenerTypes.scrollPercentage);
  };

  return {
    start: () => {
      setListener();
    },
  };
})();
